<ng-container *ngIf="isValid; else noData">
	<div class="padding-bottom-8 title-icon">
		<span class="text-uppercase text-18-bold" dcrHTMLKey="ESG_HOLDING_RANKINGS_TITLE">Top & Bottom Holdings by MSCI ESG Rating</span>
		<icon type="info-circle" class="info-circle" [tooltip-dcr]="'ESG_HOLDING_RANKINGS_TOOLTIP'" [analytic-data]="{ linkName: 'ESG_HOLDING_RANKINGS_TOOLTIP' }"></icon>
	</div>

	<div dcrHTMLKey="ESG_HOLDING_RANKINGS_TITLE_SUBTITLE" class="margin-bottom-24 text-16">
		Identify the holdings driving the ESG Rating of your portfolio and find opportunities to take action to potentially improve the overall sustainability of your portfolio.
		The range and average of ESG Ratings vary widely across region and peer groups; consider comparing funds within similar asset classes.
	</div>
	<bfa-tabs type="underline">
		<ng-container *ngFor="let tab of tabs">
			<ng-template #tabItem>
				<esg-holding-rankings-table [data]="data" [tabs]="[tab]"></esg-holding-rankings-table>
			</ng-template>
			<tab-panel [tab-title]="tab.config.title.label" [templateRef]="tabItem"></tab-panel>
		</ng-container>
	</bfa-tabs>
	<ac-tpm-disclosure></ac-tpm-disclosure>
	<ac-disclosure textClass="text-condensed-14 padding-top-16" [isExpandable]="false" [dcrKey]="disclosureKey"></ac-disclosure>
</ng-container>
<ng-template #noData>
	<dl-no-data *ngIf="shouldShowNoDataComponent" [data]="data"></dl-no-data>
</ng-template>
